import {GetStoresOptionsAvailableForReservationQuery} from '@data/__generated__/types.reservations'

import StoreLocator from './StoreLocator'

export interface Props {
  storesOptions: GetStoresOptionsAvailableForReservationQuery['stores']
}

export default function ReservationsSelectStore(props: Props) {
  const {storesOptions} = props
  return (
    <div className="py-10">
      <StoreLocator storeIds={storesOptions.map(option => option._id)} />
    </div>
  )
}
